export default "__VITE_ASSET__CihSfebG__"